module.exports = __webpack_public_path__ + "img/i-success.92012f9d.svg";